import { Routes } from '@angular/router';
import { AuthGuard } from 'app/authentication/guard/auth.guard';

import { PromptuaryExportComponent } from '../pages/promptuary-export/promptuary-export.component';

export const ExportRoutes: Routes = [
	{
		path: 'promptuary-export/:exportId',
		component: PromptuaryExportComponent,
		canActivate: [AuthGuard],
	},
];
